import { render, staticRenderFns } from "./DateConfig.vue?vue&type=template&id=00234fb8&scoped=true&"
import script from "./DateConfig.vue?vue&type=script&lang=js&"
export * from "./DateConfig.vue?vue&type=script&lang=js&"
import style0 from "./DateConfig.vue?vue&type=style&index=0&id=00234fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00234fb8",
  null
  
)

export default component.exports